import { render, staticRenderFns } from "./QStoredProcSubmenu.vue?vue&type=template&id=5f0adf95&"
import script from "./QStoredProcSubmenu.vue?vue&type=script&lang=js&"
export * from "./QStoredProcSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports